import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Input, Spin, Icon, notification } from "antd";
import "./style.css";
import { replaceElem } from "../../misc/util";
import URLRedirectsService from "../../services/URLRedirects";

const URLRedirects = () => {
  const mounted = useRef();
  const [loading, setLoading] = useState(true);
  const [newData, setData] = useState([
    {
      oldUrl: "",
      newURL: "",
    },
  ]);

  const setState = (stateFunction) => mounted.current && stateFunction();

  const getURLs = async () => {
    try {
      const response = await URLRedirectsService.getURLs();
      setState(() => setData(response.data.data));
      setState(() => setLoading(false));
    } catch (error) {
      console.error(error);
      setState(() => setLoading(false));
    }
  };

  useEffect(() => {
    mounted.current = true;
    getURLs();
    return () => {
      mounted.current = false;
    };
  }, []);

  const addUrl = () => {
    setData((prev) => [...prev, { oldUrl: "", newURL: "" }]);
  };

  const handleInputChange = (e, i) => {
    const { value, name } = e.target;
    const urlObj = newData[i];
    urlObj[name] = value;
    const filtered = replaceElem(newData, null, i, urlObj);
    setData(filtered);
  };

  const handleDelete = async (i) => {
    if (newData[i]._id) {
      setState(() => setLoading(true));
      const response = await URLRedirectsService.deleteUrl(newData[i]._id);
      setState(() => setLoading(false));
      if (response?.message !== "Deleted")
        return notification.error("An error occured");
    }
    const filtered = newData.filter((el, index) => index !== i);
    setData(filtered);
  };

  const handleSubmit = async () => {
    const dataToSend = newData.filter((el) => !el._id);
    if (!dataToSend.length) return;
    setState(() => setLoading(true));
    try {
      const response = await URLRedirectsService.createURLRedirect({
        data: dataToSend,
      });
      if (response.data.message === "CREATED") return await getURLs();
      setState(() => setLoading(false));
    } catch (error) {
      setState(() => setLoading(false));
      notification.error({ message: error.response?.data?.message });
    }
  };

  const handleUpdate = async (index) => {
    try {
      setState(() => setLoading(true));
      const data = newData[index];
      const response = await URLRedirectsService.updateURL(data);
      if (response._id) return await getURLs();
      setState(() => setLoading(false));
    } catch (error) {
      setState(() => setLoading(false));
      notification.error({ message: error.response?.data?.message });
    }
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>URL Redirects (301)</h1>
              </div>
            </div>
            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  {newData.map(({ newURL, oldUrl, _id }, i) => (
                    <div className="ant-row url-row" key={"URL-" + i}>
                      <div className="ant-col-md-9">
                        <Input
                          type="text"
                          placeholder="Old URL"
                          value={oldUrl}
                          name="oldUrl"
                          onChange={(e) => handleInputChange(e, i)}
                        />
                      </div>
                      <div className="ant-col-md-1">
                        <Icon type="arrow-right" className="url-icon" />
                      </div>
                      <div className="ant-col-md-9">
                        <Input
                          type="text"
                          placeholder="New URL"
                          value={newURL}
                          name="newURL"
                          onChange={(e) => handleInputChange(e, i)}
                        />
                      </div>
                      <div className="ant-col-md-4">
                        <Icon
                          type="delete"
                          className="cursor-pointer"
                          onClick={() => handleDelete(i)}
                        />

                        {_id && (
                          <Button
                            type="primary"
                            className="color-white update-btn"
                            onClick={() => handleUpdate(i)}
                          >
                            UPDATE
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="ant-row add-url-button">
                    <div className="ant-col-md-24">
                      <Button
                        type="primary"
                        className="color-white"
                        onClick={addUrl}
                      >
                        Add New
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="ant-row add-url-button">
            <div className="ant-col-md-24">
              <Button
                type="primary"
                className="color-white"
                loading={loading}
                onClick={handleSubmit}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default URLRedirects;
